import {Component, computed, effect, inject, input, signal} from '@angular/core';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {EventsService} from '../../../../../core/services/events.service';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'subscriber-component',
  templateUrl: './subscriber-component.html',
  styleUrls: ['./subscriber-component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule]
})

export class SubscriberComponentNew {
  private eventsService = inject(EventsService);
  private translate = inject(TranslateService);
  private snackBar = inject(MatSnackBar);
  eventData = input<any>();
  subscribers = signal<any>([]);
  id = computed(() => this.eventData().id);

  displayedColumns = ['country', 'canton', 'organization', 'reserve', 'participants'];

  constructor() {
    effect(() => {
      let id = this.id();
      if (id) {
        this.getSubscribers();
      }
    });
  }

  getSubscribers() {
    this.eventsService.getSubscribers(this.id()).subscribe((res: any) => {
      this.subscribers.set(res);
    });
  }

  saveNumberOfPlaces(data) {
    let count = +this.eventData().reserveCount;
    for (let i = 0; i < this.subscribers().length; i++) {
      if (this.subscribers()[i].organizationId !== data.organizationId) {
        count = count - this.subscribers()[i].numberOfSeats;
      }
    }
    if (count < +data.numberOfSeats) {
      let message = this.translate.instant('event.maxSeatsNumberError');
      this.snackBar.open(message, 'OK', {
        duration: 10000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: 'max-seats-number-error'
      });
    } else {
      data.editPlaces = !data.editPlaces;
      let body = {
        id: data.id,
        eventId: data.eventId,
        countryId: data.countryId,
        cityId: data.cityId,
        organizationId: data.organizationId,
        numberOfSeats: data.numberOfSeats
      };
      this.eventsService.editNumberOfSeats(body).subscribe();
    }
  }
}
